import { Col, Grid, Typography } from 'gu-ui-kit'
import React, { useEffect, useState } from 'react'
import styles from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/budget-editor.module.scss'
import clsx from 'clsx'
import AmountInput from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ModifyList/configs/subcomponents/amountInput'
import { StatusBadge } from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ModifyList/configs/subcomponents/StatusBadge'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import BudgetTypeSelect from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ModifyList/configs/subcomponents/BudgetTypeSelect'
import isEmpty from 'lodash/isEmpty'

const budgetConfig = (props) => {
  const { updateRow, resource } = props
  const breakpoints = useBreakpoint()
  const { t } = useTranslation()
  const [columnVisibility, setColumnVisibility] = useState({})

  useEffect(() => {
    if (!breakpoints.md) {
        setColumnVisibility({
          name_and_budget: true,
          name: false,
          budget: false,
          rowState: false,
        })
    } else if (!breakpoints.lg) {
        setColumnVisibility({
          name_and_budget: false,
          rowState: false,
        })
    } else {
        setColumnVisibility({ name_and_budget: false })
    }
  }, [breakpoints])

  const setBudgetType = (row, type) => {
    if (row[type] !== null) {
      return
    }

    const update = {}
    switch (type) {
      case 'budget_limit':
        update.budget_limit = +row.budget_limit_day
        update.budget_limit_day = null
        break
      case 'budget_limit_day':
        update.budget_limit = null
        update.budget_limit_day = +row.budget_limit
        break
    }

    updateRow(row.external_id, update)
  }

  const setBudgetAmount = (row, value, budget_type) =>
    row[budget_type] != value &&
    updateRow(row.external_id, {
      [budget_type]: !value ? 0 : value,
    })

  return {
    columns: [
      {
        id: 'name_and_budget',
        header: t(
          'campaigns_editor::budget_editor.table.head.name_and_budget.label',
          { context: resource },
        ),
        cell: ({ row: { original } }) => {
          const { name, rowState, budget_limit, budget_limit_day } = original

          return (
            <Grid
              direction={'column'}
              gap={8}
              alignItems="flex-start"
              className={clsx({
                [styles['modified']]:
                  rowState?.touched === true || rowState?.updated === true,
                [styles['modified_error']]:
                  rowState?.error || !isEmpty(rowState?.errors),
              })}
            >
              <Typography variant={'Body-3'} component={<div>{name}</div>} />

              {!breakpoints.md && <StatusBadge rowState={rowState} />}

              <Grid
                direction={'row'}
                gap={16}
                className={styles['budget-editor__budget-name-cell']}
                wrap={'nowrap'}
                alignItems={'flex-start'}
              >
                {budget_limit === null && budget_limit_day === null ? (
                  t(
                    'campaigns_editor::budget_editor.table.rows.optimization_enabled',
                    { context: resource },
                  )
                ) : (
                  <>
                    <Col s={'5'}>
                      <AmountInput
                        setBudgetAmount={setBudgetAmount}
                        budget_limit={budget_limit}
                        budget_limit_day={budget_limit_day}
                        original={original}
                      />
                    </Col>
                    <Col s={'6'}>
                      <BudgetTypeSelect
                        original={original}
                        setBudgetType={setBudgetType}
                      />
                    </Col>
                  </>
                )}
              </Grid>
            </Grid>
          )
        },
      },
      {
        id: 'name',
        header: t('campaigns_editor::budget_editor.table.head.name.label', {
          context: resource,
        }),
        cell: ({
          row: {
            original: { name, rowState },
          },
        }) => (
          <Grid
            direction={'column'}
            gap={8}
            alignItems="flex-start"
            className={clsx({
              [styles['modified']]:
                rowState?.touched === true || rowState?.updated === true,
              [styles['modified_error']]:
                rowState?.error || !isEmpty(rowState?.errors),
            })}
          >
            <Grid
              className={styles['budget-editor__edit-name-container']}
              fluid={false}
              direction="column"
              alignItems="flex-start"
              justifyContent="start"
              gap={4}
            >
              <Typography variant={'Body-3'} component={<div>{name}</div>} />
              {!breakpoints.lg && <StatusBadge rowState={rowState} />}
            </Grid>
          </Grid>
        ),
      },

      {
        id: 'budget',
        header: t('campaigns_editor::budget_editor.table.head.budget.label'),
        cell: ({ row: { original } }) => {
          const { budget_limit, budget_limit_day, rowState } = original

          return (
            <Grid
              gap={16}
              className={styles['budget-editor__budget-cell']}
              wrap={'nowrap'}
              alignItems={'flex-start'}
            >
              {budget_limit === null && budget_limit_day === null ? (
                t(
                  'campaigns_editor::budget_editor.table.rows.optimization_enabled',
                  { context: resource },
                )
              ) : (
                <>
                  <AmountInput
                    setBudgetAmount={setBudgetAmount}
                    budget_limit={budget_limit}
                    budget_limit_day={budget_limit_day}
                    original={original}
                    error={
                      rowState?.errors?.budget_limit ||
                      rowState?.errors?.budget_limit_day
                    }
                    touched={rowState?.touched === true}
                  />

                  <BudgetTypeSelect
                    original={original}
                    setBudgetType={setBudgetType}
                  />
                </>
              )}
            </Grid>
          )
        },
      },
      {
        id: 'rowState',
        header: ' ',
        size: 100,
        cell: ({
          row: {
            original: { rowState },
          },
        }) => <StatusBadge rowState={rowState} placement={'left'} />,
      },
    ],
    showHeader: true,
    showFooter: false,
    className: styles['budget-editor__table'],
    getRowId: ({ external_id }) => external_id,
    state: {
      columnVisibility,
    },
    ...props,
  }
}

export { budgetConfig }

